module.exports = __webpack_public_path__ + "static/will_bosworth-41ce2785cd520ead7f63b1ca9268fba0.png";